import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CreateGyanService } from '../../core/services/create-gyan/create-gyan.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { SubmitgyanService } from 'src/app/core/services/submit-gyan/submitgyan.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
    selector: 'app-draft-list',
    templateUrl: './draft-list.component.html',
    styleUrls: ['./draft-list.component.scss'],
})
export class DraftListComponent implements OnInit {
    currentDraftPage = 1;
    savedDrafts: any;
    isloading: boolean = false;
    isloadingScroll: boolean = false;
    isloadingScrollDelete: boolean = false;
    draftId: any;
    deleteDraftItem: any;
    private modalRef: NgbModalRef | undefined;
    isMobile: boolean = false;
    isDraftAvaiable = true;
    isNocontent: boolean = false;
    @ViewChild('containerDraftDiv') containerDraftDiv?: ElementRef;
    isScrolling = false;
    constructor(
        private createGyanService: CreateGyanService,
        private modalService: NgbModal,
        private toastrService: ToastrService,
        private localstorageService: LocalStorageService,
        private commonService: CommonServiceService,
        private submitGyanService: SubmitgyanService,
    ) {}

    ngOnInit() {
        this.getSavedDraft();
        this.checkWidth();
    }

    getSavedDraft() {
        this.isloading = true;
        if (this.isDraftAvaiable) {
            this.createGyanService.getSavedDrafts(this.currentDraftPage).subscribe({
                next: (res) => {
                    if (res) {
                        this.isloading = false;
                        this.addDraft(res);
                    } else {
                        console.log('No content available.');
                        this.isloading = false;
                        this.isNocontent = true;
                    }
                },
                error: (err: HttpErrorResponse) => {
                    this.isloading = false;
                    console.error('Error fetching saved drafts:', err);
                    // Optionally, show an error message to the user
                },
            });
        }
    }
    getSavedDraftonScroll() {
        this.isloadingScroll = true;
        if (this.isDraftAvaiable) {
            this.createGyanService.getSavedDrafts(this.currentDraftPage).subscribe({
                next: (res) => {
                    if (res) {
                        this.isloadingScroll = false;
                        this.addDraft(res);
                    } else {
                        console.log('No content available.');
                        this.isloadingScroll = false;
                    }
                },
                error: (err: HttpErrorResponse) => {
                    this.isloadingScroll = false;
                    console.error('Error fetching saved drafts:', err);
                    // Optionally, show an error message to the user
                },
            });
        }
    }

    addDraft(res: any) {
        if (this.currentDraftPage === 1) {
            this.savedDrafts = [];
        }
        if (res && Array.isArray(res) && res.length) {
            for (const item of res) {
                if (!this.savedDrafts.some((savedItem: any) => savedItem.id === item.id)) {
                    this.savedDrafts.push(item);
                }
            }
        } else if (!res) {
            this.isDraftAvaiable = false;
        }
        this.onDraftContinerScroll();
    }

    onDraftContinerScroll() {
        if (this.containerDraftDiv) {
            const element = this.containerDraftDiv.nativeElement;
            element.addEventListener('scroll', (event: any) => {
                const isBottom = element.scrollHeight - Math.ceil(element.scrollTop + element.clientHeight) <= 1;
                if (!this.isScrolling && isBottom) {
                    console.log('onDraftContinerScroll', this.currentDraftPage);
                    this.isScrolling = true;
                    if (this.currentDraftPage === 1) {
                        this.currentDraftPage++;
                    }
                    this.onDraftContinerScrollEnd();
                    setTimeout(() => {
                        this.isScrolling = false;
                        if (this.currentDraftPage > 1) {
                            this.currentDraftPage++;
                        }
                    }, 500);
                }
            });
        }
    }

    onDraftContinerScrollEnd() {
        // Call your function here
        console.log('End of scroll reached!');
        this.getSavedDraftonScroll();
    }

    checkForDeleteGyan(item: any, content: any) {
        this.deleteDraftItem = item;
        this.draftId = item.id;
        this.modalRef = this.modalService.open(content, { size: 'sm', centered: true, windowClass: 'custom-modal-class' });
    }

    callDeleteDraft() {
        if (this.modalRef) {
            this.modalRef.close();
        }
        const item = this.deleteDraftItem;
        this.isloadingScrollDelete = true;
        this.createGyanService.deleteDraft(this.draftId).subscribe(
            (res: any) => {
                if (res) {
                    this.isloadingScrollDelete = false;
                    this.toastrService.success(res.message);
                    // this.getSavedDraft();
                    const pendingDraft = this.savedDrafts.filter((draft: any) => item.id != draft.id);
                    this.savedDrafts = pendingDraft;

                    setTimeout(() => {
                        this.adjustDraftContainerHeight();
                    }, 0);
                }
            },
            (error) => {
                console.log(error);
                this.toastrService.error('Failed to Delete Draft');
            },
        );
    }

    adjustDraftContainerHeight() {
        const container = this.containerDraftDiv?.nativeElement;
        if (container) {
            container.style.height = container.scrollHeight > 95 ? `${container.scrollHeight - 25}px` : '95px';
        }
    }
    populateDraft(item: any) {
        const data = JSON.parse(item.data);
        this.commonService.setCallUseAsTemplate(data);
        this.commonService.setDraftLoaded(item);
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }
}
